/* eslint-disable */

interface SupportFormData {
    name: string;
    email: string;
    country: string;
    message: string;
    captchaInput: string;
    captchaId: string | null;
}

interface SupportApiResponse {
    success?: boolean;
    captcha?: boolean;
}

interface SupportPageOptions {
    // Add any options if needed in the future
}

// Type definitions for global variables
interface GlobalWindow extends Window {
    SupportPage?: SupportPageClass;
    contacts?: any;
    memberInfo?: any;
}

class SupportPageClass {
    opts: SupportPageOptions = {};
    page: HTMLElement | null = null;
    supportPage: HTMLElement | null = null;
    inputCountry: HTMLInputElement | null = null;
    inputName: HTMLInputElement | null = null;
    inputEmail: HTMLInputElement | null = null;
    inputMessage: HTMLTextAreaElement | null = null;
    countrySelect: HTMLElement | null = null;
    supportContact: HTMLElement | null = null;
    submitBtn: HTMLElement | null = null;
    resultMessage: HTMLElement | null = null;
    captchaInput: HTMLInputElement | null = null;
    contacts: any = null;
    loggedIn: any = null;

    init(): void {
        this.page = document.querySelector('.support-page');

        if (!this.page) {
            return;
        }

        this.supportPage = document.querySelector('.support-page');
        this.inputCountry = document.getElementById('SupportCountry') as HTMLInputElement;
        this.inputName = document.getElementById('SupportName') as HTMLInputElement;
        this.inputEmail = document.getElementById('SupportEmail') as HTMLInputElement;
        this.inputMessage = document.getElementById('SupportMessage') as HTMLTextAreaElement;
        this.countrySelect = document.getElementById('SelectCountry');
        this.supportContact = document.querySelector('.SupportContact');
        this.submitBtn = document.getElementById('supportSubmitBtn');
        this.resultMessage = document.getElementById('supportResultMessage');
        this.captchaInput = document.getElementById('Captcha') as HTMLInputElement;
        this.contacts = (window as GlobalWindow).contacts;

        this.loggedIn = (window as GlobalWindow).memberInfo;

        this.updateBackBtn();
        this.setListeners();
    }

    updateBackBtn(): void {
        const closeBtn = this.supportPage?.querySelector('.close-btn') as HTMLAnchorElement;

        // Check if the referrer is from the same site
        if (closeBtn && document.referrer.startsWith(window.location.origin)) {
            // If yes, update back button link
            closeBtn.href = document.referrer;
        }
    }

    setListeners(): void {
        if (this.inputMessage) {
            this.inputMessage.addEventListener('input', (e) => this.validateInput(e.currentTarget as HTMLElement));
        }
        
        if (this.inputEmail) {
            this.inputEmail.addEventListener('input', (e) => this.validateEmail(e.currentTarget as HTMLInputElement));
        }
        
        if (this.inputName) {
            this.inputName.addEventListener('input', (e) => this.validateInput(e.currentTarget as HTMLElement));
        }

        if (this.countrySelect) {
            this.countrySelect.addEventListener('click', (e: Event) => {
                e.preventDefault();
                this.countrySelect?.parentElement?.classList.toggle('is-open');
            });

            const countryOptions = this.countrySelect.parentElement?.querySelectorAll('.FilterList-inner a');
            countryOptions?.forEach(option => {
                option.addEventListener('click', (e: Event) => {
                    e.preventDefault();
                    const target = e.currentTarget as HTMLAnchorElement;
                    if (this.inputCountry) {
                        this.inputCountry.value = target.getAttribute('data-value') || '';
                    }
                    this.validateCountrySelector();
                    const filterButtonValue = document.querySelector('.FilterButton-value');
                    if (filterButtonValue) {
                        filterButtonValue.textContent = target.textContent;
                    }
                    this.countrySelect?.parentElement?.classList.remove('is-open');
                });
            });

            document.addEventListener('click', (e: Event) => {
                const target = e.target as HTMLElement;
                const clickedList = this.countrySelect?.parentElement?.contains(target) || false;
                const clickedBtn = this.countrySelect?.contains(target) || false;
                if (!clickedList && !clickedBtn) {
                    this.countrySelect?.parentElement?.classList.remove('is-open');
                }
            }, true);
        }

        if (!this.loggedIn) {
            this.initCaptcha();
        }

        if (this.submitBtn) {
            this.submitBtn.addEventListener('click', (e: Event) => {
                e.preventDefault();

                const formData = this.validateInputs();
                if (formData) {
                    this.submitBtn?.classList.add('loading');

                    fetch('/api/support/submit', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(formData)
                    })
                    .then(response => response.json())
                    .then((data: SupportApiResponse) => {
                        if (data && data.success) {
                            this.supportPage?.classList.add('request-sent');
                            this.supportPage?.classList.remove('request-error');
                        } else if (data.captcha === false) {
                            this.invalidateInput(this.captchaInput);
                            if (this.captchaInput) {
                                this.captchaInput.value = "";
                            }
                            this.updateCaptcha();
                        } else {
                            this.supportPage?.classList.add('request-error');
                        }
                    })
                    .catch((e: Error) => {
                        console.log(e);
                        this.supportPage?.classList.add('request-error');
                    })
                    .finally(() => {
                        this.submitBtn?.classList.remove('loading');
                    });
                }
            });
        }
    }

    initCaptcha(): void {
        const captchaUpdateBtn = document.querySelector(".captcha-update");

        if (captchaUpdateBtn) {
            captchaUpdateBtn.addEventListener("click", () => {
                this.updateCaptcha();
                if (this.captchaInput) {
                    this.captchaInput.value = "";
                }
            });
        }
    }

    updateCaptcha(): void {
        const captchaImage = document.querySelector(".captcha-image") as HTMLImageElement;

        if (captchaImage) {
            const captchaIdUrl = captchaImage.getAttribute("data-id-url");
            const captchaImageUrl = captchaImage.getAttribute("data-image-url");

            if (captchaIdUrl) {
                fetch(captchaIdUrl)
                    .then(response => response.text())
                    .then(newId => {
                        captchaImage.src = captchaImageUrl + "?id=" + newId;
                        captchaImage.setAttribute("data-id", newId);
                    });
            }
        }
    }

    captchaId(): string | null {
        const captchaImage = document.querySelector(".captcha-image");
        return captchaImage ? captchaImage.getAttribute("data-id") : null;
    }

    validateInputs(): SupportFormData | false {
        let valid = this.validateEmail(this.inputEmail);
        valid = valid && this.validateInput(this.inputMessage);
        valid = valid && this.validateInput(this.inputName);

        if (this.inputCountry) {
            valid = valid && this.validateCountrySelector();
        }

        if (!this.loggedIn && this.captchaInput) {
            valid = valid && this.validateInput(this.captchaInput);
        }

        if (valid) {
            return {
                name: this.inputName?.value || '',
                email: this.inputEmail?.value || '',
                country: this.inputCountry ? this.inputCountry.value : '',
                message: this.inputMessage?.value || '',
                captchaInput: this.captchaInput ? this.captchaInput.value : '',
                captchaId: this.captchaId(),
            };
        } else {
            return false;
        }
    }

    validateCountrySelector(): boolean {
        const valid = this.inputCountry && this.inputCountry.value.length > 0;
        if (valid) {
            this.countrySelect?.classList.remove("error");
        } else {
            this.countrySelect?.classList.add("error");
        }

        return valid;
    }

    validateInput(element: HTMLElement | null): boolean {
        if (!element) return false;

        const errorClass = "error";
        const inputElement = element as HTMLInputElement | HTMLTextAreaElement;

        if (inputElement.value.length === 0) {
            element.classList.add(errorClass);
            return false;
        } else {
            element.classList.remove(errorClass);
            return true;
        }
    }

    invalidateInput(element: HTMLElement | null): void {
        if (element) {
            const errorClass = "error";
            element.classList.add(errorClass);
        }
    }

    validateEmail(element: HTMLInputElement | null): boolean {
        if (!element) return false;

        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const errorClass = "error";

        if (element.value.length === 0 || !re.test(String(element.value).toLowerCase())) {
            element.classList.add(errorClass);
            return false;
        } else {
            element.classList.remove(errorClass);
            return true;
        }
    }
}

const SupportPage = new SupportPageClass();

// Expose to global scope for compatibility
(window as GlobalWindow).SupportPage = SupportPage;

document.addEventListener('DOMContentLoaded', () => {
    (window as GlobalWindow).SupportPage?.init();
}); 